import { formatNumberWithSeparator } from '../../../../utils/helpers';

export const formatAmount = (
  value: number,
  prefix: string,
  suffix?: string,
): string =>
  `${prefix}${formatNumberWithSeparator({ value, thousandsSeparator: ',' })}${suffix ? ` ${suffix}` : ''}`;
